export default __webpack_public_path__ + "static/media/close-blue.b887e8bd.svg";